<template>
  <template v-if="imgSrc">
    <v-img
      v-if="imgSrc"
      :alt="asset.name || ''"
      class="cursor-pointer"
      max-height="300px"
      :src="imgSrc"
      @click.stop="dialog = true"
    />
    <v-dialog v-model="dialog">
      <v-fab
        absolute
        icon="mdi-close"
        location="top right"
        :offset="true"
        @click="dialog = false"
      ></v-fab>
      <v-img
        v-if="imgSrc"
        :alt="asset.name || ''"
        :max-height="maxHeight"
        :src="imgSrc"
      />
    </v-dialog>
  </template>
  <a
    v-if="asset.browser_download_url && asset.name"
    :filename="asset.name"
    :href="asset.browser_download_url"
    >{{ asset.name }}</a
  >
</template>
<script setup lang="ts">
import { onMounted, type Ref, ref } from "vue";
import type { Attachment } from "../gen/forgejo-vue";
import { currentAccount } from "@/authenticationTokens";
const props = defineProps<{
  asset: Attachment;
}>();

const imgSrc: Ref<string | undefined> = ref();
const dialog = ref(false);
const maxHeight = ref(window.innerHeight);

const imageExtensions = [".png", ".jpg", ".jpeg", ".webp", ".gif"];

onMounted(async () => {
  const auth = currentAccount.value;
  const lcName = props.asset.name?.toLowerCase() ?? "";
  if (
    auth &&
    imageExtensions.some((ie) => lcName.endsWith(ie)) &&
    props.asset.browser_download_url?.startsWith(auth.server)
  ) {
    const path =
      "/proxy/" + props.asset.browser_download_url.replace(/.*\/\//, "");
    const r = await fetch(path, {
      headers: { Authorization: `token ${auth.token}` },
    });
    const blob = await r.blob();
    imgSrc.value = URL.createObjectURL(blob);
  }
});
</script>
